import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export interface LayerState {
  totality: boolean;
  obscuration: boolean;
  clouds: boolean;
  traffic: boolean;
  terrain: boolean;
}

interface LayerPanelProps {
  open: boolean;
  layers: LayerState;
  onChange: (layers: LayerState) => void;
  onClose: () => void;
}

const layerKeys: Array<keyof LayerState> = [
  'totality',
  'obscuration',
  'clouds',
  'traffic',
  'terrain',
];

export function LayerPanel({ open, layers, onChange, onClose }: LayerPanelProps) {
  const { t } = useTranslation();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCloseRef.current();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open]);
  if (!open) return null;
  return (
    <aside
      id="map-layer-panel"
      className="floating-panel layer-panel"
      aria-label={t('layers.title')}
    >
      <div className="panel-heading">
        <h2>{t('layers.title')}</h2>
        <button className="icon-button" type="button" onClick={onClose} aria-label={t('close')}>
          ×
        </button>
      </div>
      {layerKeys.map((key) => (
        <label className="toggle-row" key={key}>
          <span className={`layer-swatch swatch-${key}`} aria-hidden="true" />
          <span>{t(`layers.${key}`)}</span>
          <input
            type="checkbox"
            checked={layers[key]}
            onChange={(event) => onChange({ ...layers, [key]: event.target.checked })}
          />
        </label>
      ))}
      <p className="microcopy">{t('traffic.quotaNote')}</p>
    </aside>
  );
}
